import { Controller } from "@hotwired/stimulus"

// Minimal controller that clones an insights modal <template> into the DOM.
// The modal_controller.js handles close/escape/backdrop.
// The turbo-frame inside the modal handles lazy loading.
export default class extends Controller {
  static targets = ["template"]

  open(event) {
    event.preventDefault()
    if (!this.hasTemplateTarget) return
    const clone = this.templateTarget.content.cloneNode(true)
    document.body.appendChild(clone)
  }
}
